import React from "react";
import {Parallax} from "react-parallax";
import CTAButton from "../../../common/v2/CTA-Button/cta-button";
import styles from './ParallaxSection.module.css'

const ParallaxSection: React.FC = () => {
    return (
        <section>
            <Parallax
                bgImage="/images/home/kidscreative.jpg"
                strength={300} // Adjust this value for stronger/weaker parallax
                className={styles.section}
            >
                <div style={{
                    height: '450px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        backgroundColor: '#113265',
                        opacity: 0.8,
                        padding: '40px',
                        borderRadius: '12px',
                        textAlign: 'center',
                        color: 'white',
                        maxWidth: '80%'
                    }}>
                        <h2 style={{ fontSize: '2rem', marginBottom: '10px', fontWeight: 400 }}>
                            Bienvenue dans notre espace chaleureux!
                        </h2>
                        <p style={{ fontSize: '1.2rem', marginBottom: '20px' }}>
                            Un lieu où la créativité, l'apprentissage et la joie se rencontrent.
                        </p>
                        <CTAButton
                            text={"Réservez une visite"}
                            href={"/contact"}
                            className="custom_css"
                        />
                    </div>
                </div>
            </Parallax>
        </section>

    );
};

export default ParallaxSection;
